<template>
    <div class="grid max-w-xl grid-cols-1 gap-x-4 gap-y-4 py-2">
        <BaseInputCheckbox
            v-model="formValues.risks_acknowledgement"
            :label="$t('legal_acknowledgements.risks_acknowledgement')"
            :required="isRequiredLegalComplianceProfileAttribute('acknowledgements', 'risks_acknowledgement')"
            name="acknowledgements.risks_acknowledgement"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="formValues.anti_money_laundering"
            :required="isRequiredNaturalComplianceProfileAttribute('acknowledgements', 'anti_money_laundering')"
            :label="$t('legal_acknowledgements.anti_money_laundering')"
            name="acknowledgements.anti_money_laundering"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="formValues.authorised_signatory"
            :required="isRequiredNaturalComplianceProfileAttribute('acknowledgements', 'authorised_signatory')"
            :label="$t('legal_acknowledgements.authorised_signatory')"
            name="acknowledgements.authorised_signatory"></BaseInputCheckbox>
    </div>
</template>

<script setup lang="ts">
import BaseInputCheckbox from '../../../../../base/BaseInputCheckbox.vue'
import { isRequiredNaturalComplianceProfileAttribute } from '../../../form/forms'
import { useVModel } from '@vueuse/core'
import { isRequiredLegalComplianceProfileAttribute, LegalAcknowledgmentsOne } from '../forms'

const props = defineProps<{
    modelValue: LegalAcknowledgmentsOne
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)
</script>
